import { render, staticRenderFns } from "./presentation.html?vue&type=template&id=3529fcc4&scoped=true&external"
import script from "./presentation.js?vue&type=script&lang=js&external"
export * from "./presentation.js?vue&type=script&lang=js&external"
import style0 from "./presentation.scss?vue&type=style&index=0&id=3529fcc4&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3529fcc4",
  null
  
)

export default component.exports